import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Text from '../../typography/Text';
import Icon from '../../general/Icon';

function Step({ step, index, currentStep, classes, onClick, showConnector }) {
    const isCompleted = step?.isCompleted;
    const isActive = index === currentStep;
    const isClickable = isCompleted || isActive;

    const handleClick = isClickable && onClick ? () => onClick(index) : undefined;

    return (
        <div className={classes.stepItem}>
            <div className={classes.stepContent}>
                <div
                    className={classnames(classes.icon, {
                        [classes.iconHighlighted]: isClickable,
                    })}
                    onClick={handleClick}
                >
                    <Text type="body1">
                        {isCompleted ? (
                            <Icon name="check" size="medium" color="white" />
                        ) : (
                            index + 1
                        )}
                    </Text>
                </div>
                {step.title && (
                    <div
                        className={classnames(classes.label, {
                            [classes.labelClickable]: isClickable,
                        })}
                        onClick={handleClick}
                    >
                        <Text bold={isClickable}>{step.title}</Text>
                    </div>
                )}
            </div>
            {showConnector && (
                <div
                    className={classnames(classes.connector, {
                        [classes.connectorCompleted]: isCompleted,
                        [classes.connectorActive]: isActive,
                    })}
                />
            )}
        </div>
    );
}

Step.propTypes = {
    /** Step configuration object */
    step: PropTypes.shape({
        /** Text label for the step */
        title: PropTypes.string,
        /** Whether the step has been completed */
        isCompleted: PropTypes.bool,
    }).isRequired,
    /** Zero-based index of this step */
    index: PropTypes.number.isRequired,
    /** Index of the currently active step */
    currentStep: PropTypes.number.isRequired,
    /** Classes object provided by the styling system */
    classes: PropTypes.object.isRequired,
    /** Callback when a completed or active step is clicked */
    onClick: PropTypes.func,
    /** Whether to show the connector line to the next step */
    showConnector: PropTypes.bool,
};

export default memo(Step);
